import { ChevronRight, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

interface DocBreadcrumbsProps {
  currentTitle: string;
}

export function DocBreadcrumbs({ currentTitle }: DocBreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-2 text-sm">
        {/* Home */}
        <li>
          <Link
            to="/"
            className="flex items-center gap-1 text-gray-500 transition hover:text-sb-black"
            aria-label="Home"
          >
            <Home size={16} aria-hidden="true" />
          </Link>
        </li>

        <li aria-hidden="true">
          <ChevronRight size={16} className="text-gray-300" />
        </li>

        {/* Documentation root */}
        <li>
          <Link
            to="/documentation"
            className="text-gray-500 transition hover:text-sb-black hover:underline"
          >
            Documentation
          </Link>
        </li>

        <li aria-hidden="true">
          <ChevronRight size={16} className="text-gray-300" />
        </li>

        {/* Current page */}
        <li>
          <span className="font-medium text-sb-black" aria-current="page">
            {currentTitle}
          </span>
        </li>
      </ol>
    </nav>
  );
}
